import { select, call } from 'redux-saga/effects';
import { fetchEntityIfNeeded } from '@classpass/saga-tools';
import { userActionCampaign } from 'redux/saga/entities/bound';
import { isLoggedIn } from 'redux/saga/selectors/user';
import { deepExtract } from 'helpers/deep';
import { VENUE_DETAIL_ROUTE } from 'features/InventoryDetail/InventoryDetail.route.path';

export function* inviteAFriendOnEnter(client, nextState, replaceState) {
  let finalDestination = '/search';
  const loggedIn = yield select(isLoggedIn);
  const token = deepExtract('params.token', nextState);

  if (loggedIn && !token) {
    return yield call(replaceState, finalDestination);
  }

  try {
    const { schedule } = yield call(fetchEntityIfNeeded, userActionCampaign, [client, token], { key: token });

    if (loggedIn) {
      const studioAlias = deepExtract('venue.alias', schedule);
      const classAlias = deepExtract('class.alias', schedule);
      finalDestination = `${VENUE_DETAIL_ROUTE}/${studioAlias}/${classAlias}/${schedule.id}`;
      yield call(replaceState, finalDestination);
    }
  } catch (err) {
    if (loggedIn) {
      yield call(replaceState, finalDestination);
    } else {
      throw err;
    }
  }
}
